import { Spinner } from '@mgrvtechgroup/admin-ds';
import type { ReactNode } from 'react';

/**
 * 완료 시점을 알 수 없는 조회의 안내 한 줄(DS: 완료 시점 불명의 로딩은 Spinner).
 * 글자만 있으면 응답이 느릴 때 멈춘 것처럼 보인다. 스피너는 장식이라 보조 기기에는 글자만 읽힌다.
 */
export function InlineLoading({ children }: { children: ReactNode }) {
  return (
    <p
      role="status"
      aria-live="polite"
      className="body text-muted-foreground flex items-center gap-2"
    >
      <Spinner aria-hidden className="shrink-0" />
      {children}
    </p>
  );
}
